module.exports = __webpack_public_path__ + "img/vip-banner-bg.4810fc13.png";